<div class="chat-area col">
    <div class="chat-content {[ if (o.show_send_button) { ]}chat-content-sendbutton{[ } ]}" aria-live="polite">
        {[ if (o.muc_show_logs_before_join) { ]}
            <div class="empty-history-feedback"><span>{{{o.__('No message history available.')}}}</span></div>
        {[ } ]}
    </div>
    <div class="bottom-panel"></div>
</div>
